import theme from '@/style';
import {toPriceStr} from '@/utils';
import React from 'react';
import {useTranslation} from 'react-i18next';

export interface WonProps {
  bet?: number;
  awardAmount: number;
  result: React.ReactElement | null;
  isBet?: boolean;
}

const Won = ({bet, awardAmount = 0, result, isBet = true}: WonProps) => {
  const {i18n} = useTranslation();
  return (
    <div
      className="flex h-9 items-center justify-between rounded-[1.125rem] px-5"
      style={{backgroundColor: theme.backgroundColor.betsBgLight}}>
      <div className="flex items-center">
        {result}
        {isBet && (
          <span className="ml-3 text-sm font-bold">
            {i18n.t('game-page.label.bet')} {toPriceStr(bet)}
          </span>
        )}
      </div>
      <div className="flex items-center">
        <span className="font-bold text-[#9FA5AC]">
          {i18n.t('bets-detail.label.won')}{' '}
        </span>
        <span
          className="text-base font-bold"
          style={{color: theme.basicColor.primary}}>
          {toPriceStr(awardAmount, {fixed: 2})}
        </span>
      </div>
    </div>
  );
};

export default Won;
